.hero-header-type-1__actions-group {
  margin-top: var(--spacing-2xl);
}
